import { writable } from 'svelte/store';
export let textFilter = writable("");
export let typeFilter = writable("filterAll");
